import { Pipe, PipeTransform } from '@angular/core';
import { RichDevice, WallboxDevicesWithMatchingBoilerSerial } from '@store';
import { DeviceRoles } from '@vi-iot/client/models';

@Pipe({
  name: 'isObngWallbox',
  standalone: true,
})
export class IsObngWallboxPipe implements PipeTransform {
  transform(device: WallboxDevicesWithMatchingBoilerSerial | RichDevice): boolean {
    return IsObngWallboxPipe.isObngWallboxPipe(device);
  }

  static isObngWallboxPipe(device: WallboxDevicesWithMatchingBoilerSerial | RichDevice): boolean {
    if (!device?.roles) {
      return false;
    }

    return (
      device.roles.includes(DeviceRoles.OBNG) &&
      (device.roles.includes(DeviceRoles.InterfaceBatteryVehicleChargingStation) ||
        device.roles.includes(DeviceRoles.VCS))
    );
  }
}
